import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import WhatsAppButton from '@/components/feature/WhatsAppButton';
import useSeo from '@/hooks/useSeo';

const FINALIZADO = 'https://readdy.ai/api/search-image?query=Extremely%20realistic%20professional%20industrial%20photography%20modern%20clean%20organized%20heavy%20industrial%20workshop%20with%20large%20machinery%20hydraulic%20equipment%20steel%20components%20metallic%20surfaces%20professional%20technicians%20in%20safety%20gear%20working%20not%20facing%20camera%20cinematic%20dramatic%20lighting%20gray%20silver%20steel%20tones%20with%20subtle%20warm%20yellow%20accent%20details%20wide%20angle%20widescreen%20composition%20premium%20high%20resolution%20sharp%20depth%20industrial%20maintenance%20engineering%20reliability%20heavy%20mechanics%20pulp%20paper%20mining%20oil%20gas%20sectors%20negative%20space%20for%20title%20overlay%20clean%20backgrounds%20not%20stock%20photo%20not%20illustration%20not%203D%20render&width=1600&height=700&seq=gp-cases-unified-hero-v2&orientation=landscape';
const PERITAGEM = 'https://storage.readdy-site.link/project_files/93d54813-2fc1-4495-a318-6b5d36c5e53e/fb1c943d-1b42-48c7-a654-c32d37fc515d_compressed_PERITAGEM-ACUMULADOR-HIDRAULICO.webp';
const SPARE = 'https://storage.readdy-site.link/project_files/93d54813-2fc1-4495-a318-6b5d36c5e53e/526013d8-65a6-4f8f-8f99-5e709dd2fb09_compressed_SPARE-PARTS-ACUMULADOR-HIDRAULICO.webp';
const PRECARGA = 'https://storage.readdy-site.link/project_files/93d54813-2fc1-4495-a318-6b5d36c5e53e/97439098-e804-40f5-a54e-741b4c23dacd_compressed_PRECARGA-ACUMULADOR-HIDRAULICO.webp';
const BEXIGA = 'https://storage.readdy-site.link/project_files/93d54813-2fc1-4495-a318-6b5d36c5e53e/b4f9e416-299f-45e3-b61d-233fe197c5d8_compressed_MONTAGEM-BEXIGA-ACUMULADOR-HIDRAULICO.webp';
const VEDACOES = 'https://storage.readdy-site.link/project_files/93d54813-2fc1-4495-a318-6b5d36c5e53e/4e46b8a7-8527-4067-a4df-1236502b3ee1_compressed_MONTAGEM-VEDACOES-ACUMULADOR-HIDRAULICO.webp';
const APERTO = 'https://storage.readdy-site.link/project_files/93d54813-2fc1-4495-a318-6b5d36c5e53e/ca5b36cb-2c2e-4264-8f3e-8a1abd65f9a0_compressed_APERTO-CABECOTE-ACUMULADOR-HIDRAULICO.webp';

export default function CaseRecuperacaoAcumuladoresHidraulicosPage() {
  useSeo({
    title: 'Recuperação de Acumuladores Hidráulicos | Oficina Especializada | Grupo Pilar',
    description: 'Case de recuperação completa de acumuladores hidráulicos industriais, incluindo desmontagem, inspeções, substituição de bexiga, vedações, carregamento com nitrogênio e testes operacionais.',
    keywords: 'acumulador hidráulico, manutenção de acumulador hidráulico, reparo de acumulador hidráulico, bexiga de acumulador hidráulico, hidráulica industrial, nitrogênio acumulador hidráulico, oficina especializada, grupo pilar',
    canonical: 'https://www.pilarmanutencao.com.br/cases/recuperacao-acumuladores-hidraulicos',
    ogUrl: 'https://www.pilarmanutencao.com.br/cases/recuperacao-acumuladores-hidraulicos',
    ogImage: FINALIZADO,
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const heroImage = FINALIZADO;

  return (
    <div className="min-h-screen bg-gp-graphite">
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative min-h-[60vh] flex items-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src={heroImage}
              alt="Acumulador hidráulico industrial recuperado pela Pilar — equipamento de alta pressão desmontado, inspecionado, com bexiga e vedações substituídas, testado e pronto para operação"
              title="Recuperação de Acumuladores Hidráulicos Industriais — Case Pilar"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gp-graphite/75"></div>
          </div>
          <div className="relative z-10 w-full px-4 sm:px-6 lg:px-12 pt-28 pb-16">
            <div className="max-w-4xl">
              <div className="flex items-center gap-3 mb-6 flex-wrap">
                <span className="inline-block px-3 py-1 rounded-sm text-xs font-semibold uppercase tracking-wider bg-gp-yellow text-gp-graphite">
                  Oficina Especializada
                </span>
                <span className="text-gray-400 text-xs uppercase tracking-wider">Hidráulica Industrial</span>
                <span className="text-gray-500 text-xs">— Aracruz, ES</span>
              </div>
              <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-white uppercase leading-tight mb-6">
                <span className="text-gp-yellow">Case:</span>{' '}
                Recuperação Completa de Acumuladores Hidráulicos Industriais
              </h1>
              <p className="text-gray-300 text-lg max-w-2xl leading-relaxed">
                Recuperação completa de acumuladores hidráulicos industriais utilizados em sistemas de alta pressão,
                incluindo desmontagem controlada, inspeções técnicas detalhadas, substituição de bexigas e vedações,
                limpeza técnica, jateamento, pintura industrial, testes de estanqueidade e carregamento com nitrogênio.
              </p>
            </div>
          </div>
        </section>

        {/* Visão Geral */}
        <section className="relative py-20 overflow-hidden">
          <div className="absolute inset-0 opacity-5">
            <div
              className="absolute top-0 left-0 w-full h-full"
              style={{
                backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(255,255,255,0.15) 1px, transparent 0)',
                backgroundSize: '40px 40px',
              }}
            ></div>
          </div>
          <div className="relative z-10 px-4 sm:px-6 lg:px-12">
            <div className="max-w-6xl mx-auto">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-[3px] bg-gp-yellow"></div>
                <h2 className="font-display text-2xl md:text-3xl font-bold text-white uppercase tracking-wider">Visão Geral</h2>
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
                <div className="bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-6 md:p-8">
                  <div className="flex items-start gap-4 mb-6">
                    <div className="w-12 h-12 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                      <i className="ri-information-line text-gp-yellow text-xl w-6 h-6 flex items-center justify-center"></i>
                    </div>
                    <div>
                      <h3 className="font-display text-lg font-bold text-white uppercase mb-2">Dados do Projeto</h3>
                    </div>
                  </div>
                  <div className="space-y-3">
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-settings-3-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <div>
                        <span className="text-gp-yellow font-semibold text-sm">Equipamento</span>
                        <p className="text-gray-300 text-sm">Acumuladores Hidráulicos Industriais de Alta Pressão</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-building-2-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <div>
                        <span className="text-gp-yellow font-semibold text-sm">Segmento</span>
                        <p className="text-gray-300 text-sm">Hidráulica Industrial</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-tools-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <div>
                        <span className="text-gp-yellow font-semibold text-sm">Aplicação</span>
                        <p className="text-gray-300 text-sm">Sistemas hidráulicos industriais de alta pressão</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-team-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <div>
                        <span className="text-gp-yellow font-semibold text-sm">Equipe</span>
                        <p className="text-gray-300 text-sm">Equipe especializada em hidráulica e mecânica industrial</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-tools-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <div>
                        <span className="text-gp-yellow font-semibold text-sm">Disciplinas</span>
                        <p className="text-gray-300 text-sm">Hidráulica Industrial, Mecânica Industrial, Inspeção Técnica</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-lightbulb-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <div>
                        <span className="text-gp-yellow font-semibold text-sm">Diferencial do Projeto</span>
                        <p className="text-gray-300 text-sm">Capacidade de recuperação completa de vasos de pressão com testes de estanqueidade e carregamento com nitrogênio</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="rounded-lg overflow-hidden border border-gp-graphite-lighter bg-gp-graphite">
                  <img
                    src={PERITAGEM}
                    alt="Peritagem técnica realizada para avaliação das condições internas e definição do escopo de recuperação do acumulador hidráulico"
                    title="Peritagem técnica de acumulador hidráulico industrial — oficina Pilar"
                    className="w-full h-80 md:h-[28rem] object-contain"
                    loading="lazy"
                  />
                  <div className="bg-gp-graphite-light p-3 border-t border-gp-graphite-lighter">
                    <p className="text-gray-400 text-xs text-center">
                      Peritagem técnica realizada para avaliação das condições internas e definição do escopo de recuperação
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Desafio */}
        <section className="relative py-20 bg-gp-graphite-light">
          <div className="px-4 sm:px-6 lg:px-12">
            <div className="max-w-6xl mx-auto">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-[3px] bg-gp-yellow"></div>
                <h2 className="font-display text-2xl md:text-3xl font-bold text-white uppercase tracking-wider">Desafio</h2>
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
                <div className="bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-6 md:p-8">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                      <i className="ri-alert-line text-gp-yellow text-xl w-6 h-6 flex items-center justify-center"></i>
                    </div>
                    <div>
                      <p className="text-gray-300 text-base leading-relaxed mb-4">
                        A Pilar executa a recuperação completa de acumuladores hidráulicos industriais utilizados em sistemas de alta pressão.
                        Esses equipamentos são submetidos a condições severas de operação, exigindo inspeções detalhadas e controle rigoroso
                        durante todo o processo de recuperação para garantir segurança e confiabilidade ao equipamento.
                      </p>
                      <p className="text-gray-400 text-sm leading-relaxed mb-4">
                        As principais complexidades envolviam:
                      </p>
                      <ul className="space-y-2 mb-4">
                        <li className="flex items-start gap-2 text-gray-300 text-sm">
                          <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                          <span>Equipamentos submetidos a altas pressões hidráulicas exigindo controle rigoroso de segurança</span>
                        </li>
                        <li className="flex items-start gap-2 text-gray-300 text-sm">
                          <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                          <span>Necessidade de inspeção detalhada dos componentes internos do acumulador</span>
                        </li>
                        <li className="flex items-start gap-2 text-gray-300 text-sm">
                          <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                          <span>Avaliação estrutural do vaso de pressão quanto à integridade e condições de serviço</span>
                        </li>
                        <li className="flex items-start gap-2 text-gray-300 text-sm">
                          <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                          <span>Controle rigoroso durante desmontagem e montagem de vasos de pressão</span>
                        </li>
                        <li className="flex items-start gap-2 text-gray-300 text-sm">
                          <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                          <span>Garantia de estanqueidade e segurança operacional após a recuperação completa</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="rounded-lg overflow-hidden border border-gp-graphite-lighter bg-gp-graphite">
                  <img
                    src={SPARE}
                    alt="Levantamento técnico dos componentes necessários para recuperação completa do acumulador hidráulico"
                    title="Levantamento técnico de componentes do acumulador hidráulico"
                    className="w-full h-80 md:h-[28rem] object-contain"
                    loading="lazy"
                  />
                  <div className="bg-gp-graphite-light p-3 border-t border-gp-graphite-lighter">
                    <p className="text-gray-400 text-xs text-center">
                      Levantamento técnico dos componentes necessários para recuperação completa do acumulador hidráulico
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Escopo Executado */}
        <section className="relative py-20 overflow-hidden">
          <div className="absolute inset-0 opacity-5">
            <div
              className="absolute top-0 left-0 w-full h-full"
              style={{
                backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(255,255,255,0.15) 1px, transparent 0)',
                backgroundSize: '40px 40px',
              }}
            ></div>
          </div>
          <div className="relative z-10 px-4 sm:px-6 lg:px-12">
            <div className="max-w-6xl mx-auto">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-[3px] bg-gp-yellow"></div>
                <h2 className="font-display text-2xl md:text-3xl font-bold text-white uppercase tracking-wider">Escopo Executado pela Pilar</h2>
              </div>

              <div className="rounded-lg overflow-hidden border border-gp-graphite-lighter bg-gp-graphite mb-8">
                <img
                  src={BEXIGA}
                  alt="Instalação da nova bexiga hidráulica durante o processo de recuperação do acumulador"
                  title="Substituição da bexiga do acumulador hidráulico"
                  className="w-full h-80 md:h-[28rem] object-contain"
                  loading="lazy"
                />
                <div className="bg-gp-graphite p-3 border-t border-gp-graphite-lighter">
                  <p className="text-gray-400 text-xs text-center">
                    Instalação da nova bexiga hidráulica durante o processo de recuperação do acumulador
                  </p>
                </div>
              </div>

              <div className="space-y-4">
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <span className="text-gp-yellow font-display font-bold text-sm">01</span>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed pt-2">Desmontagem completa dos acumuladores hidráulicos com controle de segurança para vasos de pressão</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <span className="text-gp-yellow font-display font-bold text-sm">02</span>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed pt-2">Inspeção interna detalhada do corpo do acumulador e componentes mecânicos</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <span className="text-gp-yellow font-display font-bold text-sm">03</span>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed pt-2">Peritagem técnica completa de todos os componentes com relatório de avaliação</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <span className="text-gp-yellow font-display font-bold text-sm">04</span>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed pt-2">Inspeção dimensional do corpo e conexões do acumulador hidráulico com instrumentação</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <span className="text-gp-yellow font-display font-bold text-sm">05</span>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed pt-2">Substituição de bexigas conforme especificações técnicas do acumulador hidráulico</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <span className="text-gp-yellow font-display font-bold text-sm">06</span>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed pt-2">Substituição completa de vedações: anéis, gaxetas, retentores e selos do acumulador</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <span className="text-gp-yellow font-display font-bold text-sm">07</span>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed pt-2">Substituição de componentes danificados identificados durante a inspeção técnica</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <span className="text-gp-yellow font-display font-bold text-sm">08</span>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed pt-2">Limpeza técnica de todos os componentes com remoção de contaminantes e resíduos</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <span className="text-gp-yellow font-display font-bold text-sm">09</span>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed pt-2">Jateamento industrial para preparação da superfície do vaso de pressão</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <span className="text-gp-yellow font-display font-bold text-sm">10</span>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed pt-2">Pintura industrial para proteção anticorrosiva do acumulador hidráulico</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <span className="text-gp-yellow font-display font-bold text-sm">11</span>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed pt-2">Montagem completa do acumulador com controle dimensional e ajustes de precisão</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Inspeções e Testes */}
        <section className="relative py-20 bg-gp-graphite-light">
          <div className="px-4 sm:px-6 lg:px-12">
            <div className="max-w-6xl mx-auto">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-[3px] bg-gp-yellow"></div>
                <h2 className="font-display text-2xl md:text-3xl font-bold text-white uppercase tracking-wider">Inspeções e Testes</h2>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start mb-8">
                <div className="bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-6 md:p-8">
                  <div className="flex items-start gap-4 mb-6">
                    <div className="w-12 h-12 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                      <i className="ri-search-eye-line text-gp-yellow text-xl w-6 h-6 flex items-center justify-center"></i>
                    </div>
                    <div>
                      <h3 className="font-display text-lg font-bold text-white uppercase mb-2">Protocolo de Inspeções</h3>
                    </div>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed mb-4">
                    O processo de inspeção dos acumuladores hidráulicos seguiu um protocolo rigoroso, abrangendo
                    desde a verificação da integridade estrutural do vaso até a validação operacional com carregamento
                    de nitrogênio conforme especificação técnica.
                  </p>
                  <ul className="space-y-3">
                    <li className="flex items-start gap-2 text-gray-300 text-sm">
                      <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                      <span>Inspeção do corpo do acumulador quanto à integridade estrutural do vaso de pressão</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-300 text-sm">
                      <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                      <span>Inspeção das conexões com verificação de roscas, faces de vedação e integridade</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-300 text-sm">
                      <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                      <span>Inspeção dos componentes mecânicos internos do acumulador hidráulico</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-300 text-sm">
                      <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                      <span>Inspeção da bexiga quanto a desgastes, ressecamento e condições de serviço</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-300 text-sm">
                      <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                      <span>Verificação de integridade estrutural do vaso após inspeção e recuperação</span>
                    </li>
                  </ul>
                </div>

                <div className="bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-6 md:p-8">
                  <div className="flex items-start gap-4 mb-6">
                    <div className="w-12 h-12 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                      <i className="ri-test-tube-line text-gp-yellow text-xl w-6 h-6 flex items-center justify-center"></i>
                    </div>
                    <div>
                      <h3 className="font-display text-lg font-bold text-white uppercase mb-2">Testes e Validação</h3>
                    </div>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed mb-4">
                    Após a conclusão da montagem, o acumulador passou por uma bateria de testes para garantir
                    a estanqueidade, o desempenho operacional e a segurança do equipamento antes da liberação
                    para retorno ao serviço.
                  </p>
                  <ul className="space-y-3">
                    <li className="flex items-start gap-2 text-gray-300 text-sm">
                      <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                      <span>Testes de estanqueidade com verificação de vazamentos em todas as conexões e vedações</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-300 text-sm">
                      <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                      <span>Validação operacional com simulação das condições de trabalho do acumulador</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-300 text-sm">
                      <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                      <span>Carregamento com nitrogênio conforme especificação técnica do fabricante</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="rounded-lg overflow-hidden border border-gp-graphite-lighter bg-gp-graphite">
                <img
                  src={PRECARGA}
                  alt="Verificação e ajuste da pré-carga de nitrogênio conforme especificações operacionais do equipamento"
                  title="Ajuste de pré-carga de nitrogênio do acumulador hidráulico"
                  className="w-full h-80 md:h-[28rem] object-contain"
                  loading="lazy"
                />
                <div className="bg-gp-graphite p-3 border-t border-gp-graphite-lighter">
                  <p className="text-gray-400 text-xs text-center">
                    Verificação e ajuste da pré-carga de nitrogênio conforme especificações operacionais do equipamento
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Recursos Envolvidos */}
        <section className="relative py-20 overflow-hidden">
          <div className="absolute inset-0 opacity-5">
            <div
              className="absolute top-0 left-0 w-full h-full"
              style={{
                backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(255,255,255,0.15) 1px, transparent 0)',
                backgroundSize: '40px 40px',
              }}
            ></div>
          </div>
          <div className="relative z-10 px-4 sm:px-6 lg:px-12">
            <div className="max-w-6xl mx-auto">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-[3px] bg-gp-yellow"></div>
                <h2 className="font-display text-2xl md:text-3xl font-bold text-white uppercase tracking-wider">Recursos Envolvidos</h2>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-6 text-center">
                  <div className="w-14 h-14 bg-gp-yellow/10 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-drop-line text-gp-yellow text-2xl w-8 h-8 flex items-center justify-center"></i>
                  </div>
                  <h3 className="font-display text-lg font-bold text-white uppercase mb-2">Hidráulica</h3>
                  <p className="text-gray-400 text-sm">Especialização em sistemas hidráulicos de alta pressão, vasos de pressão e acumuladores industriais</p>
                </div>

                <div className="bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-6 text-center">
                  <div className="w-14 h-14 bg-gp-yellow/10 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-settings-3-line text-gp-yellow text-2xl w-8 h-8 flex items-center justify-center"></i>
                  </div>
                  <h3 className="font-display text-lg font-bold text-white uppercase mb-2">Mecânica</h3>
                  <p className="text-gray-400 text-sm">Montagem e desmontagem de componentes, controle dimensional e ajustes de precisão</p>
                </div>

                <div className="bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-6 text-center">
                  <div className="w-14 h-14 bg-gp-yellow/10 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-search-eye-line text-gp-yellow text-2xl w-8 h-8 flex items-center justify-center"></i>
                  </div>
                  <h3 className="font-display text-lg font-bold text-white uppercase mb-2">Inspeção</h3>
                  <p className="text-gray-400 text-sm">Peritagem técnica, inspeção dimensional, testes de estanqueidade e validação operacional</p>
                </div>
              </div>

              <div className="mt-8 bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-6">
                <div className="flex items-center gap-3 mb-4">
                  <i className="ri-list-check text-gp-yellow w-6 h-6 flex items-center justify-center"></i>
                  <h3 className="font-display text-base font-bold text-white uppercase">Equipe Especializada</h3>
                </div>
                <div className="flex flex-wrap gap-3">
                  <span className="inline-flex items-center gap-2 bg-gp-graphite-light border border-gp-graphite-lighter px-4 py-2 rounded-lg text-gray-300 text-sm">
                    <i className="ri-drop-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                    Hidráulica Industrial
                  </span>
                  <span className="inline-flex items-center gap-2 bg-gp-graphite-light border border-gp-graphite-lighter px-4 py-2 rounded-lg text-gray-300 text-sm">
                    <i className="ri-settings-3-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                    Mecânica Industrial
                  </span>
                  <span className="inline-flex items-center gap-2 bg-gp-graphite-light border border-gp-graphite-lighter px-4 py-2 rounded-lg text-gray-300 text-sm">
                    <i className="ri-search-eye-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                    Inspeção Técnica
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Resultados */}
        <section className="relative py-20 bg-gp-graphite-light">
          <div className="px-4 sm:px-6 lg:px-12">
            <div className="max-w-6xl mx-auto">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-[3px] bg-gp-yellow"></div>
                <h2 className="font-display text-2xl md:text-3xl font-bold text-white uppercase tracking-wider">Resultados Obtidos</h2>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
                <div className="relative rounded-lg overflow-hidden border border-gp-yellow/20 bg-gp-graphite p-6 md:p-8 order-2 lg:order-1">
                  <div className="absolute top-0 left-0 w-1 h-full bg-gp-yellow"></div>
                  <div className="flex items-start gap-4 mb-6">
                    <div className="w-12 h-12 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                      <i className="ri-trophy-line text-gp-yellow text-xl w-6 h-6 flex items-center justify-center"></i>
                    </div>
                    <div>
                      <h3 className="font-display text-xl font-bold text-white uppercase mb-2">Resultados</h3>
                    </div>
                  </div>
                  <ul className="space-y-4">
                    <li className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-refresh-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <div>
                        <span className="text-gp-yellow font-semibold text-sm">Recuperação Completa</span>
                        <p className="text-gray-400 text-sm">Acumulador hidráulico totalmente recuperado e retornado à operação com segurança</p>
                      </div>
                    </li>
                    <li className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-shield-check-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <div>
                        <span className="text-gp-yellow font-semibold text-sm">Maior Confiabilidade</span>
                        <p className="text-gray-400 text-sm">Confiabilidade do sistema hidráulico de alta pressão significativamente ampliada</p>
                      </div>
                    </li>
                    <li className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-alert-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <div>
                        <span className="text-gp-yellow font-semibold text-sm">Redução de Riscos</span>
                        <p className="text-gray-400 text-sm">Redução significativa de riscos de falhas operacionais relacionadas ao acumulador</p>
                      </div>
                    </li>
                    <li className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-timer-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <div>
                        <span className="text-gp-yellow font-semibold text-sm">Vida Útil Ampliada</span>
                        <p className="text-gray-400 text-sm">Ampliação da vida útil do acumulador hidráulico industrial</p>
                      </div>
                    </li>
                    <li className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-money-dollar-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <div>
                        <span className="text-gp-yellow font-semibold text-sm">Redução de Custos</span>
                        <p className="text-gray-400 text-sm">Custo significativamente inferior quando comparado à substituição completa do acumulador</p>
                      </div>
                    </li>
                    <li className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-test-tube-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <div>
                        <span className="text-gp-yellow font-semibold text-sm">Testes Validados</span>
                        <p className="text-gray-400 text-sm">Testes de estanqueidade e carregamento com nitrogênio realizados com sucesso</p>
                      </div>
                    </li>
                  </ul>
                </div>

                <div className="rounded-lg overflow-hidden border border-gp-yellow/20 bg-gp-graphite order-1 lg:order-2">
                  <img
                    src={FINALIZADO}
                    alt="Acumulador hidráulico recuperado pela Pilar, pronto para retorno seguro à operação"
                    title="Acumulador hidráulico recuperado — resultado final"
                    className="w-full h-80 md:h-[28rem] object-contain"
                    loading="lazy"
                  />
                  <div className="bg-gp-graphite-light p-3 border-t border-gp-graphite-lighter">
                    <p className="text-gray-400 text-xs text-center">
                      Acumulador hidráulico recuperado pela Pilar, pronto para retorno seguro à operação
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Diferenciais da Pilar */}
        <section className="relative py-20 overflow-hidden">
          <div className="absolute inset-0 opacity-5">
            <div
              className="absolute top-0 left-0 w-full h-full"
              style={{
                backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(255,255,255,0.15) 1px, transparent 0)',
                backgroundSize: '40px 40px',
              }}
            ></div>
          </div>
          <div className="relative z-10 px-4 sm:px-6 lg:px-12">
            <div className="max-w-6xl mx-auto">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-[3px] bg-gp-yellow"></div>
                <h2 className="font-display text-2xl md:text-3xl font-bold text-white uppercase tracking-wider">Diferenciais da Pilar</h2>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5 hover:border-gp-yellow/30 transition-colors duration-300">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <i className="ri-tools-line text-gp-yellow w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed">Capacidade de recuperação completa de acumuladores hidráulicos na oficina especializada Pilar</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5 hover:border-gp-yellow/30 transition-colors duration-300">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <i className="ri-team-line text-gp-yellow w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed">Equipe especializada em hidráulica industrial e componentes de sistemas de alta pressão</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5 hover:border-gp-yellow/30 transition-colors duration-300">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <i className="ri-search-eye-line text-gp-yellow w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed">Execução de inspeções técnicas detalhadas com peritagem e relatório técnico completo</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5 hover:border-gp-yellow/30 transition-colors duration-300">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-double-line text-gp-yellow w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed">Utilização de componentes adequados à aplicação conforme especificações do fabricante</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5 hover:border-gp-yellow/30 transition-colors duration-300">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <i className="ri-building-line text-gp-yellow w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed">Estrutura completa para desmontagem, jateamento, pintura e testes de acumuladores</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5 hover:border-gp-yellow/30 transition-colors duration-300">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <i className="ri-test-tube-line text-gp-yellow w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed">Realização de testes de estanqueidade e carregamento com nitrogênio antes da entrega ao cliente</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Galeria Técnica */}
        <section className="relative py-20 bg-gp-graphite-light">
          <div className="px-4 sm:px-6 lg:px-12">
            <div className="max-w-6xl mx-auto">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-[3px] bg-gp-yellow"></div>
                <h2 className="font-display text-2xl md:text-3xl font-bold text-white uppercase tracking-wider">Galeria Técnica</h2>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                {/* Foto 1 — Spare Parts */}
                <div className="relative rounded-lg border border-gp-graphite-lighter bg-gp-graphite">
                  <div className="h-64 md:h-72 flex items-center justify-center">
                    <img
                      src={SPARE}
                      alt="Levantamento técnico dos componentes necessários para recuperação completa do acumulador hidráulico"
                      title="Levantamento técnico de componentes do acumulador hidráulico"
                      className="w-full h-full object-contain"
                      loading="lazy"
                    />
                  </div>
                  <div className="absolute bottom-2 left-2 bg-gp-graphite/80 px-2 py-1 rounded-sm">
                    <span className="text-gp-yellow text-xs font-semibold">Foto 1</span>
                  </div>
                </div>
                {/* Foto 2 — Pré-carga */}
                <div className="relative rounded-lg border border-gp-graphite-lighter bg-gp-graphite">
                  <div className="h-64 md:h-72 flex items-center justify-center">
                    <img
                      src={PRECARGA}
                      alt="Verificação e ajuste da pré-carga de nitrogênio conforme especificações operacionais do equipamento"
                      title="Ajuste de pré-carga de nitrogênio do acumulador hidráulico"
                      className="w-full h-full object-contain"
                      loading="lazy"
                    />
                  </div>
                  <div className="absolute bottom-2 left-2 bg-gp-graphite/80 px-2 py-1 rounded-sm">
                    <span className="text-gp-yellow text-xs font-semibold">Foto 2</span>
                  </div>
                </div>
                {/* Foto 3 — Peritagem */}
                <div className="relative rounded-lg border border-gp-graphite-lighter bg-gp-graphite">
                  <div className="h-64 md:h-72 flex items-center justify-center">
                    <img
                      src={PERITAGEM}
                      alt="Peritagem técnica realizada para avaliação das condições internas e definição do escopo de recuperação"
                      title="Peritagem técnica de acumulador hidráulico industrial"
                      className="w-full h-full object-contain"
                      loading="lazy"
                    />
                  </div>
                  <div className="absolute bottom-2 left-2 bg-gp-graphite/80 px-2 py-1 rounded-sm">
                    <span className="text-gp-yellow text-xs font-semibold">Foto 3</span>
                  </div>
                </div>
                {/* Foto 4 — Vedações */}
                <div className="relative rounded-lg border border-gp-graphite-lighter bg-gp-graphite">
                  <div className="h-64 md:h-72 flex items-center justify-center">
                    <img
                      src={VEDACOES}
                      alt="Troca completa dos elementos de vedação para garantir estanqueidade e confiabilidade operacional"
                      title="Montagem das vedações no cabeçote do acumulador"
                      className="w-full h-full object-contain"
                      loading="lazy"
                    />
                  </div>
                  <div className="absolute bottom-2 left-2 bg-gp-graphite/80 px-2 py-1 rounded-sm">
                    <span className="text-gp-yellow text-xs font-semibold">Foto 4</span>
                  </div>
                </div>
                {/* Foto 5 — Bexiga */}
                <div className="relative rounded-lg border border-gp-graphite-lighter bg-gp-graphite">
                  <div className="h-64 md:h-72 flex items-center justify-center">
                    <img
                      src={BEXIGA}
                      alt="Instalação da nova bexiga hidráulica durante o processo de recuperação do acumulador"
                      title="Substituição da bexiga do acumulador hidráulico"
                      className="w-full h-full object-contain"
                      loading="lazy"
                    />
                  </div>
                  <div className="absolute bottom-2 left-2 bg-gp-graphite/80 px-2 py-1 rounded-sm">
                    <span className="text-gp-yellow text-xs font-semibold">Foto 5</span>
                  </div>
                </div>
                {/* Foto 6 — Aperto Cabeçote */}
                <div className="relative rounded-lg border border-gp-graphite-lighter bg-gp-graphite">
                  <div className="h-64 md:h-72 flex items-center justify-center">
                    <img
                      src={APERTO}
                      alt="Montagem e aperto final do cabeçote conforme procedimento técnico de recuperação"
                      title="Aperto final do cabeçote do acumulador com ferramenta especializada"
                      className="w-full h-full object-contain"
                      loading="lazy"
                    />
                  </div>
                  <div className="absolute bottom-2 left-2 bg-gp-graphite/80 px-2 py-1 rounded-sm">
                    <span className="text-gp-yellow text-xs font-semibold">Foto 6</span>
                  </div>
                </div>
                {/* Foto 7 — Finalizado */}
                <div className="relative rounded-lg border border-gp-graphite-lighter bg-gp-graphite">
                  <div className="h-64 md:h-72 flex items-center justify-center">
                    <img
                      src={FINALIZADO}
                      alt="Acumulador hidráulico recuperado, testado e pronto para retorno à operação industrial"
                      title="Acumulador hidráulico finalizado — resultado Pilar"
                      className="w-full h-full object-contain"
                      loading="lazy"
                    />
                  </div>
                  <div className="absolute bottom-2 left-2 bg-gp-graphite/80 px-2 py-1 rounded-sm">
                    <span className="text-gp-yellow text-xs font-semibold">Foto 7</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Serviços Relacionados */}
        <section className="relative py-16 overflow-hidden border-t border-gp-graphite-lighter">
          <div className="px-4 sm:px-6 lg:px-12">
            <div className="max-w-4xl mx-auto">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-[3px] bg-gp-yellow"></div>
                <h2 className="font-display text-lg font-bold text-white uppercase tracking-wider">Serviços Relacionados</h2>
              </div>
              <div className="flex flex-wrap gap-3">
                <Link
                  to="/hidraulica-industrial"
                  className="inline-flex items-center gap-2 bg-gp-graphite border border-gp-graphite-lighter hover:border-gp-yellow/30 px-5 py-3 rounded-lg text-gray-300 hover:text-gp-yellow text-sm font-medium transition-all duration-300"
                >
                  <i className="ri-arrow-right-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                  Hidráulica Industrial
                </Link>
                <Link
                  to="/mecanica-industrial"
                  className="inline-flex items-center gap-2 bg-gp-graphite border border-gp-graphite-lighter hover:border-gp-yellow/30 px-5 py-3 rounded-lg text-gray-300 hover:text-gp-yellow text-sm font-medium transition-all duration-300"
                >
                  <i className="ri-arrow-right-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                  Mecânica Industrial
                </Link>
                <Link
                  to="/oficina"
                  className="inline-flex items-center gap-2 bg-gp-graphite border border-gp-graphite-lighter hover:border-gp-yellow/30 px-5 py-3 rounded-lg text-gray-300 hover:text-gp-yellow text-sm font-medium transition-all duration-300"
                >
                  <i className="ri-arrow-right-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                  Oficina Especializada
                </Link>
                <Link
                  to="/acumuladores-hidraulicos"
                  className="inline-flex items-center gap-2 bg-gp-graphite border border-gp-graphite-lighter hover:border-gp-yellow/30 px-5 py-3 rounded-lg text-gray-300 hover:text-gp-yellow text-sm font-medium transition-all duration-300"
                >
                  <i className="ri-arrow-right-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                  Acumuladores Hidráulicos
                </Link>
                <Link
                  to="/cases"
                  className="inline-flex items-center gap-2 bg-gp-graphite border border-gp-graphite-lighter hover:border-gp-yellow/30 px-5 py-3 rounded-lg text-gray-300 hover:text-gp-yellow text-sm font-medium transition-all duration-300"
                >
                  <i className="ri-arrow-right-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                  Mais Cases de Sucesso
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Final */}
        <section className="relative py-20 bg-gp-graphite-light overflow-hidden">
          <div className="px-4 sm:px-6 lg:px-12">
            <div className="relative rounded-xl overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-gp-yellow/20 to-gp-graphite"></div>
              <div className="absolute inset-0 bg-gp-graphite/60"></div>
              <div className="relative z-10 p-8 md:p-12 text-center">
                <h2 className="font-display text-2xl md:text-3xl font-bold text-white uppercase mb-4">
                  Precisa de recuperação de acumuladores hidráulicos ou componentes de sistemas de alta pressão?
                </h2>
                <p className="text-gray-300 max-w-2xl mx-auto mb-8 leading-relaxed">
                  Conte com a estrutura completa da oficina especializada Pilar para recuperação de acumuladores hidráulicos industriais,
                  incluindo desmontagem controlada, inspeções técnicas detalhadas, substituição de bexigas e vedações,
                  jateamento, pintura, testes de estanqueidade e carregamento com nitrogênio.
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                  <a
                    href="https://wa.me/5527993092922"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-3 bg-gp-yellow hover:bg-gp-yellow-dark text-gp-graphite px-8 py-4 rounded-full font-semibold text-sm uppercase tracking-wider transition-all duration-300 hover:scale-105 whitespace-nowrap"
                  >
                    <div className="w-10 h-10 bg-gp-graphite rounded-full flex items-center justify-center">
                      <i className="ri-whatsapp-line text-gp-yellow w-5 h-5 flex items-center justify-center"></i>
                    </div>
                    <span>Solicitar Orçamento</span>
                    <i className="ri-arrow-right-up-line w-5 h-5 flex items-center justify-center"></i>
                  </a>
                  <Link
                    to="/contato"
                    className="inline-flex items-center justify-center gap-2 border border-gray-500 hover:border-gp-yellow text-gray-300 hover:text-gp-yellow px-8 py-4 rounded-full font-semibold text-sm transition-all duration-300 whitespace-nowrap"
                  >
                    <i className="ri-mail-line text-lg w-6 h-6 flex items-center justify-center"></i>
                    Falar com Especialista
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Back to Cases */}
        <section className="py-10 border-t border-gp-graphite-lighter">
          <div className="px-4 sm:px-6 lg:px-12">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
              <Link
                to="/cases"
                className="inline-flex items-center gap-2 text-gray-400 hover:text-gp-yellow transition-colors duration-300 text-sm uppercase tracking-wider"
              >
                <i className="ri-arrow-left-line w-5 h-5 flex items-center justify-center"></i>
                Voltar para Cases
              </Link>
              <Link
                to="/"
                className="inline-flex items-center gap-2 text-gray-400 hover:text-gp-yellow transition-colors duration-300 text-sm uppercase tracking-wider"
              >
                <i className="ri-home-line w-5 h-5 flex items-center justify-center"></i>
                Voltar para Home
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppButton />

      {/* Schema JSON-LD */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Article',
            headline: 'Recuperação Completa de Acumuladores Hidráulicos Industriais | Case Grupo Pilar',
            description: 'Case de recuperação completa de acumuladores hidráulicos industriais, incluindo desmontagem, inspeções, substituição de bexiga, vedações, carregamento com nitrogênio e testes operacionais.',
            image: heroImage,
            author: {
              '@type': 'Organization',
              name: 'Grupo Pilar',
              url: 'https://www.pilarmanutencao.com.br',
            },
            publisher: {
              '@type': 'Organization',
              name: 'Grupo Pilar',
              logo: {
                '@type': 'ImageObject',
                url: '/images/MARCA/LOGO-GRUPO-PILAR/LOGO-GRUPO-PILAR.png',
              },
            },
            datePublished: '2025-12-05',
            dateModified: '2026-06-23',
            mainEntityOfPage: {
              '@type': 'WebPage',
              '@id': 'https://www.pilarmanutencao.com.br/cases/recuperacao-acumuladores-hidraulicos',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: 'Home',
                item: 'https://www.pilarmanutencao.com.br',
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: 'Cases de Sucesso',
                item: 'https://www.pilarmanutencao.com.br/cases',
              },
              {
                '@type': 'ListItem',
                position: 3,
                name: 'Recuperação Completa de Acumuladores Hidráulicos Industriais',
                item: 'https://www.pilarmanutencao.com.br/cases/recuperacao-acumuladores-hidraulicos',
              },
            ],
          }),
        }}
      />
    </div>
  );
}